import styled from 'styled-components';
import { mixins } from '@sy/component-library';
import backgroundFigureSrc from './background-figure.svg';
import {
	CONTENT_MAX_WIDTH,
	CONTENT_VIEWPORT_WIDTH,
	POST_GRID_GAP,
	POSTS_PER_ROW_BELOW_MEDIUM,
	POSTS_PER_ROW_BELOW_LARGE,
	POSTS_PER_ROW_ABOVE_LARGE,
} from './constants';

const { media } = mixins;

export const Content = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: center;
	width: ${CONTENT_VIEWPORT_WIDTH}%;
	max-width: ${CONTENT_MAX_WIDTH}px;
	margin: 60px auto;

	${media.belowMedium`
		margin-top: 40px;
	`};
`;

export const PostGrid = styled.div`
	display: grid;
	gap: ${POST_GRID_GAP}px;
	grid-template-columns: repeat(${POSTS_PER_ROW_ABOVE_LARGE}, 1fr);
	width: 100%;
	${media.belowLarge`
		grid-template-columns: repeat(${POSTS_PER_ROW_BELOW_LARGE}, 1fr);
	`}

	${media.belowMedium`
		grid-template-columns: repeat(${POSTS_PER_ROW_BELOW_MEDIUM}, 1fr);
	`}
`;

export const BackgroundWrap = styled.div`
	width: 100%;
	background-color: ${({ theme }) => theme.colors.blue.dark};
	background-image: url('${backgroundFigureSrc}');
	background-position: center;
`;

export const Wrap = styled.div`
	width: 100%;
	max-width: 1200px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 0 24px;
`;

export const SelectedCategory = styled.div`
	background-color: ${({ theme }) => theme.colors.blue.extraLight};
	height: 40px;
	border-radius: 24px;
	padding: 8px 16px;
	color: ${({ theme }) => theme.colors.blue.main};
	font-weight: 700;
	font-size: 1.4rem;
	line-height: 2.4rem;
	margin-top: 60px;
`;

export const Title = styled.h1`
	color: ${({ theme }) => theme.colors.white};
	font-size: 4.8rem;
	line-height: 4.8rem;
	font-weight: bold;
	margin: 24px 0;
	text-align: center;
	${media.belowMedium`
		font-size: 3.2rem;
	`}
`;

export const Subtitle = styled.span`
	color: ${({ theme }) => theme.colors.white};
	font-size: 1.8rem;
	line-height: 2.7rem;
	margin-bottom: 84px;
	text-align: center;
	${media.belowMedium`
		font-size: 1.6rem;
	`}
`;

export const LoadTrigger = styled.div`
	height: 0;
`;

export const NoMorePosts = styled.div`
	padding: 8px 8px 24px 8px;
	text-align: center;
	font-size: 1.8rem;
	line-height: 2.7rem;
`;
